import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { clearParams } from '~/shared';
import {
  ReportsCampaignsModelView,
  SponsoredProductsReportsCampaignsDto,
} from '~/types';

export const GET_SPONSORED_PRODUCTS_REPORTS_CAMPAIGNS_QUERY_KEY =
  'GET_SPONSORED_PRODUCTS_REPORTS_CAMPAIGNS_QUERY';

function getSponsoredProductsReportsCampaigns(
  params: SponsoredProductsReportsCampaignsDto
) {
  const clearedParams = clearParams(
    params
  ) as SponsoredProductsReportsCampaignsDto;

  return serviceApi.get<ReportsCampaignsModelView>(
    `/ReportProdutoPatrocinado/Campaigns`,
    {
      params: clearedParams,
    }
  );
}

export function useGetSponsoredProductsReportsCampaigns(
  params: SponsoredProductsReportsCampaignsDto
) {
  return useQuery({
    queryKey: [GET_SPONSORED_PRODUCTS_REPORTS_CAMPAIGNS_QUERY_KEY, params],
    queryFn: () => getSponsoredProductsReportsCampaigns(params),
    select: data => data.data,
  });
}
